"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaviconUpdateService = void 0;
class FaviconUpdateService {
    static updateFavicons(enable2025BrandIcons) {
        this.setFavicon(enable2025BrandIcons);
        this.setAppleTouchIcons(enable2025BrandIcons);
    }
    static setFavicon(enable2025BrandIcons) {
        const favicon = document.querySelector('link[rel="shortcut icon"]');
        if (!favicon) {
            return;
        }
        if (favicon && enable2025BrandIcons) {
            favicon.href = `${STATICS_PATH}/${ASSETS_PREFIX}/favicon/favicon-2025.ico`;
        }
        else {
            favicon.href = `${STATICS_PATH}/${ASSETS_PREFIX}/favicon/favicon.ico`;
        }
    }
    static setAppleTouchIcons(enable2025BrandIcons) {
        const appleTouchIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');
        if (!appleTouchIcons || appleTouchIcons.length === 0) {
            return;
        }
        const basePath = `${STATICS_PATH}/${ASSETS_PREFIX}/favicon/`;
        appleTouchIcons.forEach(link => {
            const sizes = link.getAttribute("sizes") || "96x96";
            link.href = `${basePath}favicon-${sizes}${enable2025BrandIcons ? "-2025" : ""}.png`;
        });
    }
}
exports.FaviconUpdateService = FaviconUpdateService;
